var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_1224_1441)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1224_1441",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1224_1441",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1224_1441",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVhJREFUWEftlLFKxEAQhv8JvoH4BHZa+xyi6FVaSSbgNTYW2hgszkYQqzizYKGCcJWdjSDY2FjZ2VnZ2dkZGMmxwnHGSzz27kCSKpBZvi//zA5hyg9NmY9GoEng/yWQpulMmqZ53dsVNIF2uz2b57kzswtVvakjEUyAmecBXANYAvBpZsvOudsqiWACBShJko6Z7Xnoh5mtOOfuhkkEFShAzHwCYKd4J6J3AKsi8vCbRHABL3FWBOKhb0S0JiKPZRJjEfASlwA2PPSViNZF5GlQ4ocAM1vV4IzynYheoihqZVn23H9+YgJ+Jg5F5GCoQBzH96P8YWl/ieYALHr4kYjsV7YgBDxJkgUz6/bBj0VkdyJDWAI/FZHetRy7wCAcQKaq2xNZRCXwc1Xdqmpp0D3AzFIsQwBXqrpZBe8NZ52iv9Qwc1dVW3XPBBeoC/6uawSaBJoEmgS+AJaYbyGaTMMdAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.57eb8d8f1455cb28679363aee5f03b16.svg";
export { ForwardRef as ReactComponent };